import { Component, OnInit, Input, TemplateRef, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchConditionService } from 'src/app/shared/service/search-condition.service';
import { SearchTag } from './../../model/search-tag.model';
import { SearchTagService } from '../../service/search-tag.service';
import { SearchService } from '../../service/search/search.service';
import { SearchCondition } from '../../model/search-condition.model';
import { PageEnums } from '../../enum/page-enums';
import { MailCustomTagService } from '../../service/mail-custom-tag.service';
import { MailCustomTag } from '../../model/mail-custom-tag.model';
import { closeOpen } from 'src/app/shared/animations/open-close.animations';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-tag-list',
  templateUrl: './search-tag-list.component.html',
  styleUrls: ['./search-tag-list.component.scss'],
  animations: [closeOpen()]
})
export class SearchTagListComponent implements OnInit, OnDestroy {
  @Input() open: boolean;
  @Input() searchSide: string;
  @Input() searchService: SearchService;
  @Input() searchParams: SearchCondition;
  @Input() page;
  detailPages: string[] = [PageEnums.project_detail, PageEnums.worker_detail];
  searchTags: Array<SearchTag>;
  qoalaTags: Array<SearchTag>;
  userTags: Array<SearchTag>;
  customTags: MailCustomTag[];
  targetCustomTag: MailCustomTag;
  selectedTagIds: number[] = [];
  private subscriptions: Subscription = new Subscription();

  constructor(
    private modalService: NgbModal,
    private searchTagService: SearchTagService,
    private searchConditionService: SearchConditionService,
    private mailCustomTagService: MailCustomTagService
  ) {}

  ngOnInit() {
    const allTagsSub = this.mailCustomTagService.allTags$
      .asObservable()
      .subscribe(tags => (this.customTags = tags));
    this.subscriptions.add(allTagsSub);

    const searchTagListStateSub = this.searchTagService.searchTagListState.subscribe(res => {
      this.getSearchTags();
    });
    this.subscriptions.add(searchTagListStateSub);

    this.getSearchTags();

    const searchResetStateSub = this.searchService.searchResetState.subscribe(res => {
      this.resetSearchTags();
    });
    this.subscriptions.add(searchResetStateSub);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getSearchTags(): void {
    const params = { search_side: this.searchSide };
    const getSearchTagsSub = this.searchTagService.getSearchTags(params).subscribe(res => {
      this.searchTags = res.body.search_tags;
      this.qoalaTags = this.searchTags.filter(
        tag => tag.tag_type === 'qoala_tag'
      );
      this.userTags = this.searchTags.filter(
        tag => tag.tag_type !== 'qoala_tag'
      );
    });
    this.subscriptions.add(getSearchTagsSub);
  }

  resetSearchTags(): void {
    this.searchService.setSearchTags([]);
    this.searchTags.map(searchTag => (searchTag.is_activated = false));
  }

  clickedQoalaTag(): void {
    // アクティブになってるTagのIDを抽出
    const activatedTagIds = this.searchTagService.getActivatedTagIds(
      this.searchTags
    );
    // sessionStorageに保存
    this.searchService.setSearchTags(activatedTagIds);
    // 検索実行
    this.searchService.searchStartSubject.next();
  }

  clickedUserTag(searchTag: SearchTag) {
    // ユーザタグ条件を上書き
    this.searchConditionService.overRideSearchTagCondition(
      this.searchParams,
      searchTag
    );
    // 検索実行
    this.searchService.searchStartSubject.next();
    const updateLastUsedTimeSub = this.searchTagService.updateLastUsedTime(searchTag).subscribe(res => {});
    this.subscriptions.add(updateLastUsedTimeSub);
  }

  isDetailPage(): boolean {
    return this.detailPages.includes(this.page);
  }

  selectTag(activated: boolean, tagId: number): void {
    if (!activated) {
      this.selectedTagIds.push(tagId);
    } else {
      this.selectedTagIds = this.selectedTagIds.filter(id => id !== tagId);
    }

    this.searchParams.mail_custom_tag_ids = this.selectedTagIds;
    this.searchService.searchStartSubject.next();
  }

  openConfirmDeleteCustomTagModal(tag: MailCustomTag, content: TemplateRef<any>) {
    this.targetCustomTag = tag;
    this.modalService.open(content, { centered: true });
  }

  // 緑タグ 削除
  deleteCustomTag(): void {
    const deleteTagsSub = this.mailCustomTagService.deleteTags(this.targetCustomTag.id).subscribe(_ => {
      this.modalService.dismissAll();
      this.selectedTagIds = this.selectedTagIds.filter(id => id !== this.targetCustomTag.id);
    });
    this.subscriptions.add(deleteTagsSub);
  }
}
